import React, { FC, Fragment } from 'react'

import { Footer } from 'app/components/footer'

export const Layout: FC = ({children}) => (
  <Fragment>
    {children}
    <Footer />
  </Fragment>
)